import { IconProps } from './index';

const Pointer: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title && <title id={titleId}>{title}</title>}
            <path
                d="M0.232559 4.3969C-0.08276 4.26998 -0.0790503 4.08115 0.25358 3.97033L12.0539 0.0315584C12.381 -0.0774048 12.5683 0.105852 12.4768 0.42655L9.10477 12.2429C9.01203 12.5704 8.81109 12.5852 8.66146 12.2862L5.84462 6.64427L0.232559 4.3969ZM3.25591 4.27308L6.74049 5.66917L8.62004 9.43459L10.8124 1.75144L3.25529 4.27308H3.25591Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default Pointer;
